import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid, Cell } from 'formlabs-web-components/Grid';
import { Header } from 'formlabs-web-components/Type';
import TextPlugin from '../cms/TextPlugin';
import {
  FormSubmit,
  MarketoForm,
  Message,
  Input,
  PresetSelect,
  PhoneInput,
  TextArea
} from '../form-builder';

import './ContactSales.module.css';

const ContactSalesForm = ({
  title,
  boldTitle,
  buttonText,
  body,
  resellerVariant = false
}) => {
  const { t } = useTranslation();

  const formProps = {
    name: 'Contact_Sales',
    errorMessage: t(
      'There was an error submitting your request. Please try again!'
    ),
    successMessage: t('Thanks for your submission.'),
    trackingLabel: resellerVariant
      ? 'Connect Me With a Reseller Form Submitted'
      : 'Contact Sales Form Submitted',
    analyticsTrackMapping: { email: 'Email' },
    analyticsIdentifyMapping: {
      userId: 'Email',
      traits: { email: 'Email', firstName: 'FirstName', lastName: 'LastName' }
    },
    marketoOptions: {
      munchkinId: '060-UIG-504',
      baseUrl: 'https://app-sj15.marketo.com',
      formId: resellerVariant ? '1625' : '1001'
    }
  };

  return (
    <Fragment>
      <Grid direction="x" gutters="margin">
        <Cell mediumSize={24}>
          <Header level={4} displayAs={4} weight={boldTitle ? 700 : 400}>
            {resellerVariant ? t('Find a Reseller') : title}
          </Header>
          {resellerVariant && (
            <p>
              {t(
                'In a hurry? Leave your information and we will connect you with an Authorized Reseller in your country.'
              )}
            </p>
          )}
        </Cell>
        <Cell mediumSize={24}>
          <TextPlugin body={body}>{body}</TextPlugin>
        </Cell>
      </Grid>
      <MarketoForm {...formProps}>
        <Grid direction="x" gutters="margin">
          <Cell mediumSize={12}>
            <Input
              name="FirstName"
              label={t('First name')}
              type="text"
              isRequired
            />
          </Cell>
          <Cell mediumSize={12}>
            <Input
              name="LastName"
              label={t('Last name')}
              type="text"
              isRequired
            />
          </Cell>
        </Grid>
        <Grid direction="x" gutters="margin">
          <Cell mediumSize={resellerVariant ? 12 : 6}>
            <Input
              name="Email"
              label={t('Business email')}
              type="email"
              isRequired
            />
          </Cell>
          <Cell mediumSize={resellerVariant ? 12 : 6}>
            <PhoneInput name="Phone" label={t('Phone')} isRequired />
          </Cell>
          <Cell mediumSize={resellerVariant ? 12 : 6}>
            <Input name="Company" label={t('Company')} type="text" isRequired />
          </Cell>
          <Cell mediumSize={resellerVariant ? 12 : 6}>
            <PresetSelect
              name="NumberOfEmployees"
              label={t('Company Size')}
              type="companySize"
              isRequired
            />
          </Cell>
        </Grid>
        <Grid direction="x" gutters="margin">
          <Cell mediumSize={resellerVariant ? 12 : 6}>
            <PresetSelect
              name="How_would_you_describe_yourself__c"
              label={t('Occupation')}
              type="occupation"
              isRequired
            />
          </Cell>
          <Cell mediumSize={resellerVariant ? 12 : 6}>
            <PresetSelect
              name="Country"
              secondaryName="State"
              label={t('Country')}
              type="countryAndUsState"
              isRequired
            />
          </Cell>
          <Cell mediumSize={12}>
            <PresetSelect
              name="Industry"
              label={t('Industry')}
              type="industry"
              isRequired
            />
          </Cell>
        </Grid>
        <Grid direction="x" gutters="margin" primaryAlignment="align-center">
          <Cell mediumSize={24}>
            <TextArea
              name={
                resellerVariant ? 'Customized_Message__c' : 'Sales_Question__c'
              }
              label={t('How can we help you?')}
              rows={3}
              isRequired
            />
          </Cell>
        </Grid>
        <Grid direction="x" gutters="margin">
          <Cell mediumSize={24}>
            <FormSubmit label={buttonText} />
          </Cell>
          <Cell mediumSize={16} secondaryAlignment="align-self-middle">
            <Message type="error" />
            <Message type="success" />
          </Cell>
        </Grid>
      </MarketoForm>
    </Fragment>
  );
};

export default ContactSalesForm;
